export default "__VITE_ASSET__po6zqoMX__"